import { AddOnIds } from "enums";
import { type PackOverview, type PackTrialPeriod } from "../types/state";
import { type AddOn } from "features/Accounts/types";
import { PricingTypes } from "enums/licensing/pricingTypes";

export const getIsTrialAllowed = (item: PackOverview): boolean => {
  if (item.packPricingTypeId !== PricingTypes.Paid || item.isTrial || item.isExpired) {
    return false;
  }

  return item.pricingSettings?.isTrialAllowed ?? false;
};

export const getTrialPeriod = (item: PackOverview): PackTrialPeriod | undefined => {
  if (item.packPricingTypeId === PricingTypes.Paid) {
    return item.pricingSettings?.trialPeriod;
  }
};

export const isPurchasePackAddonEnabled = (addOns: { items?: AddOn[] } | undefined): boolean =>
  Array.isArray(addOns?.items)
    ? addOns.items.some((addon) => addon.id === AddOnIds.PurchasePacks && addon.isEnabled)
    : false;

export const getRequestLabelText = (packPricingTypeId: number, hasPurchasePackAddon: boolean) => {
  if (!hasPurchasePackAddon || packPricingTypeId === PricingTypes.Other) {
    return "Request Pack";
  }

  return packPricingTypeId === PricingTypes.Paid ? "Purchase Pack" : "Add to Account";
};

export const isFreePricingType = (packPricingTypeId: number) => packPricingTypeId === PricingTypes.Free;
export const isOtherPricingType = (packPricingTypeId: number) => packPricingTypeId === PricingTypes.Other;
export const isPaidPricingType = (packPricingTypeId: number) => packPricingTypeId === PricingTypes.Paid;
